export default "__VITE_ASSET__997fe47f__"